enum CURRENCIES_PARAMS {
    TOKEN_PARAM = 'tokenName',
    USD_VALUE_PARAM = 'usdValue',
    BALANCE_PARAM = 'tokenBalance',
}

export { CURRENCIES_PARAMS };
